module.exports = __webpack_public_path__ + "ac3ba8.png?4aa77aa57258d60561677aed58931b02";